module.exports = __webpack_public_path__ + "a4ada7668f1337eacf5a15b4720a7e65.pdf";